import React from "react";
import { useMsal } from "@azure/msal-react";
import { Text } from "@fluentui/react";

async function handleLogout(instance) {
    await instance.logoutRedirect().catch(e => {
        console.error(e);
    });
}

const SubscriptionDetails = (props) => {
    const { instance } = useMsal();
    const { subscriptionData } = props;

    return (
        <div style={{ width: '50rem', marginTop: '0.5vh', marginBottom: '-0.5vh' }}>
            <Text style={{fontSize:"1.5vh"}}>Purchased License Quantity: <b>{subscriptionData.purchasedSeatsCount}</b></Text> <br/>
            <Text style={{fontSize:"1.5vh"}}>Available License Quantity: <b>{subscriptionData.availableSeatsCount}</b></Text> <br/>
            <Text style={{fontSize:"1.5vh"}}>Assigned License Quantity: <b>{subscriptionData.assignedSeatsCount}</b></Text>
        </div>
    );
}

export default SubscriptionDetails;